<template>
  <div>
    <SearchComponent
      :backFalg="true"
      :isAdd="true"
      :authIdentity="authIdentity"
      :selectOrInputList="selectOrInputList"
      @on-search="handleSearch"
      @on-reset="handleReset"
      @on-add="handleAdd"
      @back="back"
      :isDefault="true"
      :defaultSearch="{planName: purchasePlanData.name }"
    ></SearchComponent>
    <TablePublic
      :colLists="colLists"
      :tableData="tableData"
      :cell-style="cellStyle"
      :total="total"
      :pageParams="queryParams"
      @pageChange="getList"
    >
      <template slot="statusText" slot-scope="scope">
        <el-tag :type="scope.data.statusTextColor">{{ scope.data.statusText }}</el-tag>
      </template>
      <template slot="solts" slot-scope="scope">
        <el-button
          v-hasPermi="[authIdentity + ':task']"
          class="button"
          type="text"
          size="small"
          @click="handleTask(scope.data, '任务')"
          :disabled="![1,6].includes(scope.data.status) || 
            !(scope.data.unitPrice && 
              scope.data.planToPickTotalNetWeight && 
              scope.data.ripenessLevelSpecAttrValueKey
            )
          "
        >派发任务</el-button>
        <el-button
          v-hasPermi="[authIdentity + ':edit']"
          @click="handleEdit(scope.data, scope.$index)"
          type="text"
          size="small"
          class="button"
          :disabled="![1,6].includes(scope.data.status)"
        >修改</el-button>
        <el-button
          v-hasPermi="[authIdentity + ':detail']"
          @click="handleView(scope.data, scope.$index)"
          type="text"
          size="small"
          class="button"
        >详情</el-button>
        <el-button
          v-hasPermi="[authIdentity + ':del']"
          @click="handleDel(scope.data, scope.$index)"
          type="text"
          size="small"
          class="delbutton"
        >删除</el-button>
      </template>
    </TablePublic>

    <!-- 弹窗区域 -->
    <Mdialog
      :title="title"
      :visible.sync="dialogVisible"
      width="60%"
      :close-on-click-modal="false"
      :append-to-body="true"
      @closes="cancel"
    >
      <component v-if="dialogVisible" :ref="currentView" :is="currentView" :type="type"></component>
      <span slot="footer">
        <el-button :disabled="loading" class="batch-button" @click="cancel">取 消</el-button>
        <el-button :loading="loading" class="line-button" @click="submitFrom">确 定</el-button>
      </span>
    </Mdialog>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/statusConstants'
import { mapState, mapActions } from 'vuex'
import { getPickBatchList, getDropPlantationList, delPickBatch } from '@/api/system/manage'
import SearchComponent from '@/components/searchComponent'
import Mdialog from '@/components/Mdialog'
import TablePublic from '@/components/tablePublic'
import Task from '@/views/pick/taskPick/components/form' //派发任务
import Detail from '@/views/procure/plan/components/detail'
import { isDef } from '@/utils/is'
export default {
  components: {
    TablePublic,
    SearchComponent,
    Mdialog,
    Task,
    Detail,
  },
  data() {
    const _this = this
    return {
      loading: false,
      authIdentity: 'procure:proDetail',
      dialogVisible: false,
      title: '',
      currentView: '',
      type: '',
      colLists: [
        {
          prop: 'bizNo',
          label: '采摘批次',
          isTrue: true,
          width: '130',
        },
        {
          prop: 'pickingDate',
          label: '采摘日期',
          isTrue: true,
          width: '130',
        },
        {
          prop: 'plantationBizNo',
          label: '果园编号',
          isTrue: true,
          width: '130',
        },
        {
          prop: 'plantationName',
          label: '果园名称',
          isTrue: true,
          width: '130',
          align: 'left',
        },
        {
          prop: 'cropBrandKeyValue',
          label: '产品名称',
          isTrue: true,
          width: '130',
        },
        {
          prop: 'spec',
          label: '规格',
          isTrue: true,
          width: '130',
          align: 'left',
        },
        {
          prop: 'planToPickTotalQuantity',
          label: '计划采摘总筐数',
          isTrue: true,
          width: '130',
        },
        {
          prop: 'plannedNetWeightPerUnit',
          label: '计划单筐净重(斤)',
          isTrue: true,
          width: '130',
        },
        {
          prop: 'planToPickTotalNetWeight',
          label: '计划采摘总净重(斤)',
          isTrue: true,
          width: '150',
        },
        {
          prop: 'unitPrice',
          label: '单价(元)',
          isTrue: true,
          formatter(row) {
            return _this.formatPrice(row.unitPrice)
          },
        },
        {
          prop: 'totalAmount',
          label: '合计(元)',
          isTrue: true,
          formatter(row) {
            return _this.formatPrice(row.totalAmount)
          },
        },
        {
          prop: 'actualTotalNetWeight',
          label: '实际采摘总净重(斤)',
          isTrue: true,
          width: '150',
        },
        {
         prop: 'processFactoryName',
         label: '加工厂',
         isTrue: true,
         width: '100'
        },
        {
          prop: 'ownerName',
          label: '园主/场长',
          isTrue: true,
          width: '100',
        },
        {
          prop: 'ownerContact',
          label: '联系方式',
          isTrue: true,
          width: '130',
        },
        {
          prop: 'supervisor',
          label: '监园人员',
          isTrue: true,
          width: '130',
        },
        {
          prop: 'pesticideTestResult',
          label: '农残',
          isTrue: true,
          width: '100',
        },
        {
          prop: 'heavyMetalTestResult',
          label: '重金属',
          isTrue: true,
          width: '100',
        },
        {
          prop: 'statusText',
          label: '状态',
          isTrue: true,
          width: '100',
          formSolt: true,
        },
        {
          label: '操作',
          prop: 'address',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 260,
          rightFlag: true,
        },
      ],
      total: 0,
      queryParams: {},
      tableData: [],
      selectOrInputList: [
        {
          model: 'planName',
          placeholder: '计划名称',
          class: 'home',
          disabled: true,
          type: 'input',
        },
        {
          model: 'bizNo',
          placeholder: '请输入采摘批次',
          class: 'home',
          type: 'input',
        },
        {
          model: 'plantationId',
          placeholder: '请选择果园',
          value: 'id',
          label: 'name',
          list: [],
          type: 'select',
        },
        {
          model: 'cultivationMethodSpecValueKey',
          placeholder: '请选择培育方式',
          value: 'dictLabel',
          label: 'dictLabel',
          list: [],
          type: 'select',
        },
        {
          model: 'status',
          placeholder: '请选择状态',
          value: 'value',
          label: 'label',
          list: CONSTANTS.pickStatus,
          type: 'select',
        },
        {
          model: 'supervisorName',
          placeholder: '请输入监园人员',
          class: 'home',
          type: 'input',
        },
      ],
    }
  },
  computed: {
    ...mapState({
      purchasePlanData: (state) => state.manage.infoDetail || {},
      dictList: (state) => state.system.dictList || [],
      cultivationList: (state) => (state.system.dictList && state.system.dictList.cultivationMethod) || [],
    }),
  },
  created() {
    this.getDictList({ types: 'productType,cultivationMethod', productName: '柑果' })
    this.getPlantationList()
  },
  mounted() {
    if (this.purchasePlanData && this.purchasePlanData.id) {
      this.queryParams = {
        purchasePlanId: this.purchasePlanData.id,
      }
      this.getList()
    }
  },
  updated() {
    this.selectOrInputList[3].list = this.cultivationList
  },
  methods: {
    ...mapActions({ getDictList: 'system/getDictList' }),
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (
        isDef(row.planToPickTotalNetWeight) &&
        isDef(row.actualTotalNetWeight) &&
        row.planToPickTotalNetWeight !== row.actualTotalNetWeight &&
        [9, 12].includes(columnIndex)
      ) {
        return {
          background: '#feeaea',
        }
      }
    },
    getPlantationList() {
      getDropPlantationList()
        .then((res) => {
          if (res.flag) {
            this.selectOrInputList[2].list = res.data
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getList(pageData) {
      if (pageData) {
        this.queryParams = Object.assign(this.queryParams, pageData)
      }
      getPickBatchList(this.queryParams)
        .then((res) => {
          if (res.flag) {
            this.tableData = res.data.items.map((item) => {
              item.pickingDate = this.parseTime(item.pickingDateTime, '{y}-{m}-{d}')
              item.supervisor = JSON.parse(item.supervisorIdList || '[]')
                .map((d) => d.userName)
                .join(',')
              item.statusText = CONSTANTS.getStatusConversion(item.status, 'pickStatus')
              item.statusTextColor = CONSTANTS.getStatusConversionColor(item.status, 'pickStatus')
              return item
            })
            this.total = res.data.totalCount
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    submitFrom() {
      this.loading = true
      this.$refs[this.currentView]
        .submit()
        .then(() => {
          this.loading = false
          this.cancel()
          this.getList()
        })
        .catch(() => {
          this.loading = false
        })
    },
    cancel() {
      if (this.loading) {
        return
      }
      this.dialogVisible = false
    },
    back() {
      this.$router.push({ path: '/plan' })
    },
    handledetail() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.title = '查看采购计划'
        this.currentView = 'Detail'
        this.type = 'detail'
      })
    },
    handleEdit(row) {
      this.$router.push({
        path: '/proedit',
        query: {
          id: row.id,
          type: 'update',
        },
      })
    },
    handleAdd() {
      this.$router.push({
        path: '/proedit',
        query: {
          type: 'save',
        },
      })
    },
    handleView(row) {
      this.$router.push({
        path: '/proRecord',
        query: {
          id: row.id,
        },
      })
    },
    handleTask(row) {
      this.type = 'add'
      this.title = '派发任务'
      this.dialogVisible = true
      this.currentView = 'task'
      this.$nextTick(() => {
        if (row) {
          this.$refs[this.currentView].getDetails(row)
        }
      })
    },
    // 删除
    handleDel(row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonClass: 'confirm_button',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          delPickBatch(row.id).then((response) => {
            if (response.code == 200 && response.flag) {
              this.$message.success(`删除成功！`)
              this.getList()
            } else {
              this.$message.warning(response.message)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    handleSearch(query) {
      this.queryParams.pageNo = 1
      this.queryParams = Object.assign(this.queryParams, query)
      this.getList()
    },
    handleReset() {
      this.queryParams = {
        pageNo: 1,
        purchasePlanId: this.purchasePlanData.id,
      }
      this.getList()
    },
  },
}
</script>
<style scoped lang='less'>
@import '../../../assets/tableList.less';
.progress {
  height: 48px;
}
/deep/ .el-progress-circle {
  width: 48px !important;
  height: 48px !important;
}
/deep/ .el-progress__text {
  font-size: 12px !important;
}
.progress {
  margin-bottom: 0px;
  padding-bottom: 0px;
  // width: 50px;
  // height: 50px;
}
// @import '../../../../assets/form.less';
</style>